import { motion } from "framer-motion";
import { GraduationCap, Award, BookOpen, CheckCircle2 } from "lucide-react";
import { IMAGES } from "@/data";

const credentials = [
  { icon: GraduationCap, text: "Bachelor's Degree in Social Work" },
  { icon: Award, text: "CDA in Family Childcare" },
  { icon: BookOpen, text: "Completed the Teachers of Tomorrow program" },
];

export default function About() {
  return (
    <section id="about" className="py-20 md:py-28 px-5 md:px-10">
      <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="relative order-2 lg:order-1"
        >
          <div className="rounded-[2rem] overflow-hidden shadow-xl -rotate-1">
            <img
              src={IMAGES.about}
              alt="Caregiver helping a child learn"
              className="w-full h-[440px] object-cover"
            />
          </div>
          <div className="absolute -bottom-6 right-6 bg-sky-400 text-white rounded-2xl shadow-xl px-6 py-4 rotate-2">
            <p className="text-3xl font-extrabold">15+</p>
            <p className="text-sm font-semibold">years caring for little ones</p>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="order-1 lg:order-2"
        >
          <span className="text-sm font-semibold tracking-wider uppercase text-amber-500">
            About Our Provider
          </span>
          <h2 className="mt-3 text-3xl sm:text-4xl font-bold tracking-tight text-slate-900">
            A trusted home where children thrive
          </h2>
          <p className="mt-5 text-lg text-slate-600 leading-relaxed">
            Blessed Beginnings is a home-based learning center built on love, safety, and
            genuine connection. Our provider brings professional training and a heartfelt
            commitment to early childhood education — guiding each child's growth with
            patience and warmth.
          </p>

          <div className="mt-8 space-y-4">
            {credentials.map((c, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 15 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.1 }}
                className="flex items-center gap-4 bg-white rounded-2xl p-4 border border-slate-100 shadow-sm"
              >
                <span className="flex items-center justify-center w-12 h-12 rounded-xl bg-sky-50 text-sky-500 shrink-0">
                  <c.icon className="w-6 h-6" />
                </span>
                <span className="font-semibold text-slate-800">{c.text}</span>
                <CheckCircle2 className="w-5 h-5 text-emerald-400 ml-auto shrink-0" />
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
